import React from "react";

const ContentPrivacyPolicy = () => {
  const LAST_UPDATED = "October 29, 2024";
  const EMAIL_SUPPORT = "support@theraindropcompany.com";

  return (
    <div className="flex flex-col gap-8">
      <h1 className="font-bold text-4xl">Privacy Policy</h1>
      <p className="text-color-dark-text-secondary">
        Last updated: <strong>{LAST_UPDATED}</strong>
      </p>

      <h2 className={"font-bold text-2xl"}>1. Introduction</h2>
      <p>Welcome to The Raindrop Company ("we", "our", "us").</p>
      <p>
        We respect your privacy and are committed to protecting your personal
        data. We provide this privacy policy to inform you about how we collect,
        use, disclose, and otherwise process personally identifiable information
        that we collect both online and offline.
      </p>
      <p>
        This privacy policy applies to our social media application, Raindrop,
        which allows users to connect with each other and donate to various
        organisations.
      </p>

      <h2 className={"font-bold text-2xl"}>2. Data we collect</h2>
      <p>
        When you use our app, we may collect various types of information, which
        may include:
        <ul className="flex flex-col gap-2 pt-4 ml-4">
          <li>
            • Identifiers such as name, postal address, unique personal
            identifier, online identifier, Internet Protocol (IP) address, email
            address, account name, or other similar identifiers.
          </li>
          <li>
            • Commercial information, including records of products or services
            purchased, obtained, or considered.
          </li>
          <li>
            • Internet or other similar network activity including, but not
            limited to, browsing history, search history, and information
            regarding a consumer’s interaction with our website, application or
            advertisement.
          </li>
          <li>• Donations made through our platform.</li>
        </ul>
      </p>

      <h2 className={"font-bold text-2xl"}>3. How we use your data</h2>
      <p>
        We use your data for purposes described in this policy or as disclosed
        to you in connection with our Services. For example, we might use the
        data to:
        <ul className="flex flex-col gap-2 pt-4 ml-4">
          <li>• Provide, maintain and improve our Services.</li>
          <li>• Personalize user experiences on our platform.</li>
          <li>
            • Process donations and facilitate secure payment transactions.
          </li>
          <li>• Better understand how users access and use our Services.</li>
          <li>
            • Respond to user comments and questions and provide customer
            service.
          </li>
        </ul>
      </p>

      <h2 className={"font-bold text-2xl"}>4. Sharing Of Your Data</h2>
      <p>
        We do not sell your personal data to third parties. We might share your
        personal data with third parties as described in this section:
        <ul className="flex flex-col gap-2 pt-4 ml-4">
          <li>• To process donations and complete transactions.</li>
          <li>• In case of a legal requirement or dispute.</li>
          <li>
            • To detect, prevent, or otherwise address fraud, security, or
            technical issues.
          </li>
        </ul>
      </p>

      <h2 className={"font-bold text-2xl"}>5. Security of Your Data</h2>
      <p>
        We employ a variety of measures designed to protect your information
        from unauthorized access, disclosure, alteration, and destruction. These
        include physical, electronic, and administrative safeguards.
      </p>

      <h2 className={"font-bold text-2xl"}>6. Updating Your Information</h2>
      <p>
        You can access, update, or delete your personal data using our
        application.
      </p>
      <p>
        If you need further assistance, you can contact us directly at{" "}
        {EMAIL_SUPPORT}.
      </p>

      <h2 className={"font-bold text-2xl"}>7. Children's Privacy</h2>
      <p>
        Our Services are not targeted to children, and we do not knowingly
        collect personally identifiable information from children under 18 years
        of age.
      </p>

      <h2 className={"font-bold text-2xl"}>
        8. Changes to This Privacy Policy
      </h2>
      <p>
        We may change this privacy policy from time to time, and if we do, we
        will post any changes on this page. If you continue to use our Services
        after these changes take effect, you agree to the revised policy.
      </p>

      <h2 className={"font-bold text-2xl"}>9. Contact Us</h2>
      <p>
        If there are any questions regarding this privacy policy, you may
        contact us using the information below:
      </p>
      <div>
        <p>THE RAINDROP GROUP LIMITED</p>
        <p>86-90 Paul Street</p>
        <p>London</p>
        <p>EC2A 4NE</p>
      </div>
      <p>
        <strong>{EMAIL_SUPPORT}</strong>
      </p>

      <h2 className={"font-bold text-2xl"}>10. Effective Date</h2>
      <p>
        This policy is effective as of <strong>{LAST_UPDATED}</strong>.
      </p>
    </div>
  );
};

const StratusPrivacyPolicy = () => {
  return (
    <div
      id={"page--about-us"}
      className="flex flex-col w-full py-12 justify-center items-center "
    >
      <div className="flex flex-col w-full gap-6  ">
        <ContentPrivacyPolicy />
      </div>
    </div>
  );
};

export default StratusPrivacyPolicy;
